<template>
    <div class="container-fluid">

        <div class="page-title">
            <h4>Extraction</h4>
        </div>

        <div class="card align-items-center">
            <div v-for="struct in structure" v-bind:key="struct.id">
                <div class="card-block"> 
                    <extraction ref="extraction" :subscriptionOK="_props.subscriptionOK" :start_date="default_start_date"></extraction>    
                </div>
            </div>

<!-- ############################################## -->
        <div class="card-block w-100">
            <div class="table-overflow">
                <table id="dt-opt" class="table table-lg table-striped text-center">
                    <thead>
                        <tr>
                            <th class="pointer" @click="sort('periode')" :class="[sortBy === 'periode' ? sortDirection : '']">Période demandée</th>
                            <th class="pointer" @click="sort('cible')" :class="[sortBy === 'cible' ? sortDirection : '']">Cible</th>
                            <th class="pointer" @click="sort('media_id')" :class="[sortBy === 'media_id' ? sortDirection : '']">Date</th>
                            <th class="pointer" @click="sort('status')" :class="[sortBy === 'status' ? sortDirection : '']" >Avancement</th>
                            <th class="pointer" @click="sort('medias_id')" :class="[sortBy === 'medias_id' ? sortDirection : '']" >Rapport</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="extraction in extractions" v-bind:key="extraction.id" >

                        <td class="align-middle">{{extraction.selected_start_date.substring(0,10)}} au {{extraction.selected_end_date.substring(0,10)}}</td>
                            
                        <td  v-if="extraction.selected_by == 'systems'" class="align-middle"><b>Outil</b> : 
                            <span v-if="extraction.selected != null"> {{extraction.selected.name}}  ( {{extraction.selected.code}} ) </span>
                            <span v-else> {{extraction.selected_by_code}}</span>
                        </td>
                        <td  v-if="extraction.selected_by == 'adherents'" class="align-middle"><b>Adhérent</b> : 
                            <span v-if="(extraction.selected != null) && (Array.isArray(extraction.selected)) && (extraction.selected.length > 0)"> {{extraction.selected[0].title}} {{extraction.selected[0].lastname}}  {{extraction.selected[0].firstname}} ( {{extraction.selected[0].code}} ) </span>
                            <span v-else> {{extraction.selected_by_code}}</span>
                        </td> 
                        <td  v-if="extraction.selected_by == 'sensors'" class="align-middle"><b>Compteur</b> : 
                            <span v-if="extraction.selected != null"> {{extraction.selected.name}} </span>
                            <span v-else> {{extraction.selected_by_code}}</span>
                        </td>     
                        <td  v-if="extraction.selected_by == 'all_systems'" class="align-middle">
                            <span>Intégralité du parc</span>
                        </td>                       
                        <td class="align-middle">
                            Demandé le {{extraction.created_at}}    
                            <br>
                            <span v-if="extraction.medias_id != null"> Généré le {{extraction.updated_at}} </span>
                        </td>
<!-- * * * * * * * * * * * Avancement * * * * * * * * * * *  -->
                        <td v-if="extraction.status == 0" class="align-middle">En attente de traitement</td>

                        <td v-else-if="extraction.status ==1" class="align-middle">En cours ...</td>

                        <td v-else-if="extraction.status ==2" class="align-middle">En cours de traitement</td>

                        <td v-else-if="extraction.status ==3" class="align-middle">Demande traitée </td>
                        
                        <td v-else-if="extraction.status ==4" class="align-middle"> Erreur </td>
                        
                        <td v-else-if="extraction.status ==5" class="align-middle"> Système non affecté</td>
                        
                        <td v-else-if="extraction.status == 6" class="align-middle"> Pas assez de données sur la période</td>

                        <td v-else-if="extraction.status == 7" class="align-middle">En cours <br> Erreur potentielle</td>
                        
                        <td v-else-if="extraction.status == 8" class="align-middle"> Erreur potentielle</td>
                        
                        <td v-else-if="extraction.status == 9 || extraction.status == 10 " class="align-middle"> Demande traitée <br> L'email n'a pas pu être envoyé</td>

                        <td v-else-if="extraction.status == 11" class="align-middle"> La structure n'as pas d'outil</td>

                        <td v-else-if="extraction.status == 14" class="align-middle"> Compteur sans remontée d'information</td>

                        <td v-else-if="extraction.status == 16" class="align-middle"> Aucune réservation de l'adhérent</td>

                        <td v-else-if="extraction.status == 17" class="align-middle"> Pas de compteur sur la période</td>

                        <td v-else-if="extraction.status == 18" class="align-middle"> Période d'extraction trop grande pour parc</td>

                        <td v-else class="align-middle"> Erreur </td>

                        

<!-- * * * * * * * * * * * Fin Avancement * * * * * * * * * * *  -->
                        <td v-if="extraction.medias_id != null" class="align-middle">  

                            <b-link v-if="extraction.medias_id != null" class="btn btn-info m-auto" 
                                :href="url_media(extraction.medias_id)" download 
                                :title="title(extraction)">
                                <i class="ti-download "></i>
                            </b-link></td>
                        <td v-else  class="align-middle"> 
                            <i v-if="status(extraction.status)" class="ti-close text-danger"></i>
                            <i v-else class=""><b-spinner small></b-spinner></i>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>


<!-- ############################################## -->        


        </div>
    </div>

</template>

<script>
    import api from "../config/_api";
    import Extraction from "../components/Extraction/Extraction.vue";
    import { mapGetters } from 'vuex';
    //import extractions from "../store/modules/extractions";

    export default {
        name: "Extractions",
        components: {
            'extraction' : Extraction
        },
        data() {
            return {
                sortBy:"",
                sortDirection:"asc",
                start_date : "",
                default_start_date : "",
            }
             
        },
        props: {
            subscriptionOK : Boolean,
            required: true,
            system: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                        code: "",
                    }
                }
            },
            adherent: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        lastname: "",
                        code: "",
                    }
                }
            },
            sensor: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                systems: 'systems/systems',
                adherents: 'adherents/adherents',
                sensors: 'sensors/sensors',
                extractions: 'extractions/extractions',
                structure : 'structure/structure'
            }),
        },
        beforeMount(){

        }, 
        mounted() {
            this.$store.dispatch('extractions/getExtractions');
            this.$store.dispatch('sensors/getSensors');
            this.$store.dispatch('systems/getSystems');
            this.$store.dispatch('adherents/getAdherents');
            this.$store.dispatch('structure/getStructure');
            this.default_start_date = new Date();
            this.default_start_date.setDate(0);
        },
        methods : {
            status(value){
                    if(4<=value & value<=8 || 11<=value & value<=18 ){ // 4,5,6,7,8,11      value in {4,5,6,7,8,11,12,13,14,15,16,17,18}
                        return true;
                    }
                    return false; // 0,1,2,3,9,10
            },
            sort(valeur){    
                if(valeur === this.sortBy) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                }
                this.sortBy = valeur;

                return this.extractions.sort((p1,p2) => {
                    let modifier = 1;
                    if(this.sortDirection === 'desc') modifier = -1;

                    if(this.sortBy == "periode"){
                        let selected_date="selected_start_date";
                        if((p1["selected_start_date"] == p2["selected_start_date"])){
                            selected_date="selected_end_date";
                        }
                        if(p1[selected_date] < p2[selected_date]) return -1 * modifier; 
                        if(p1[selected_date] > p2[selected_date]) return 1 * modifier;
                        return 0;
                    }
                    else if(this.sortBy == "cible"){
                        if(p1["selected_by"]< p2["selected_by"]) return -1 * modifier; 
                        if(p1["selected_by"] > p2["selected_by"]) return 1 * modifier;
                        if(p1["selected"]["code"] < p2["selected"]["code"]) return -1 * modifier; 
                        if(p1["selected"]["code"] > p2["selected"]["code"]) return 1 * modifier;
                        return 0;
                    }
                    else if(this.sortBy == "media_id"){
                        let p1_filter = "updated_at";
                        let p2_filter = "updated_at";
                        if(p1["media_id"] == null) {
                            p1_filter = "created_at";
                        }
                        if(p2["media_id"] == null) {
                            p2_filter = "created_at";
                        }
                        if(p1[p1_filter] < p2[p2_filter]) return -1 * modifier; if(p1[p1_filter] > p2[p2_filter]) return 1 * modifier;
                        return 0;
                    }
                    else{
                        if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                        return 0;
                    }
                });

            },
            getDate(date){
                var d = new Date(date);
                var day = d.getDay();
                var m = d.getMonth();
                var y = d.getFullYear();
                var fulldate=y+"-";
                if(m<10) fulldate+="0";
                fulldate+=m+"-";
                if(day<10) fulldate+="0";
                fulldate+=day;
                return fulldate;
            },
            url_media(id) {
                return api.url + 'medias/download/' + id + '?structure_id=' + this.$store.getters.structure_id;
            },
            title(extraction){
                var title= "";
                if(extraction.selected_by=="systems"){
                    if(extraction.selected != null){
                        title+="Outil : ' "+extraction.selected.name
                    }
                    else{
                        title+="Outil : ' "+extraction.selected_by_code
                    }
                }
                else if(extraction.selected_by=="adherents"){
                    if(extraction.selected != null){
                        if(Array.isArray(extraction.selected) && extraction.selected.length>=1){
                            title+="Adhérent : ' "+extraction.selected[0].lastname
                        }
                        else{
                            title+="Adhérent : ' "+extraction.selected.lastname
                        }
                    }
                    else{
                        title+="Adhérent : ' "+extraction.selected_by_code
                    }
                }
                else if(extraction.selected_by=="sensors"){
                    if(extraction.selected != null){
                        title+="Compteur : ' "+extraction.selected.name
                    }
                    else{
                        title+="Compteur : ' "+extraction.selected_by_code
                    }
                }
                if(extraction.selected != null){
                    title+= " ( "+extraction.selected.code+" ) "
                }
                title+= "' du "+extraction.selected_start_date.substring(0,10)+" au "+extraction.selected_end_date.substring(0,10);
                return title;
            }
        }
    }
    
</script>

<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
</style>